import axios from 'axios';

import { env } from '@/constants/env';
import type { ApiEnvelope } from '@/types/api';
import type { AuthResponse, LoginCredentials } from '@/types/auth';

/**
 * Deliberately bypasses the shared Axios instance (`httpClient`): the
 * shared instance's response interceptor triggers this same refresh flow
 * on 401, and reusing it here would risk recursive refresh attempts.
 */
const refreshClient = axios.create({
  baseURL: env.VITE_API_BASE_URL,
  timeout: env.VITE_API_TIMEOUT,
});

export const authService = {
  async login(credentials: LoginCredentials): Promise<AuthResponse> {
    const response = await refreshClient.post<ApiEnvelope<AuthResponse>>('/auth/admin/login', credentials);
    return response.data.data;
  },

  async refreshToken(refreshToken: string): Promise<AuthResponse> {
    const response = await refreshClient.post<ApiEnvelope<AuthResponse>>('/auth/refresh', { refreshToken });
    return response.data.data;
  },

  async logout(refreshToken: string): Promise<void> {
    await refreshClient.post('/auth/logout', { refreshToken });
  },
};
